import useRouter from './hooks/useRouter/useRouter';
export * from './types';
export * from './consts';
export * from './hooks/useRouter/useRouter';
export default useRouter;
